import { fetchJSON } from "@/api/utils.js";

export function getHappinessScores(data) {
    const url = "/api/happiness-score/";
    return fetchJSON(
        url,
        data,
        null,
        "get",
    );
}

export function setHappinessScores(data) {
    const url = "/api/happiness-score/";
    return fetchJSON(
        url,
        null,
        data,
        "post",
    );
}